import {
    selectAll,
    selectArr,
    toggleClass,
    removeClassAll,
    selectDoc,
    event,
    toggleClassAll,
    addClassAll,
    hasClass, styles, ajax
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";
import {inputEmail, inputEmpty, inputPassword} from "../helpers/service.validator";

const props = {
    // Services
    pageContainer: selectDoc('#PageContainer'),
    tabsButtons: selectAll('button.tab-title'),
    defaultTab: selectDoc('.tab-title.default'),
    navBarDesktop: selectDoc('#navbar'),
    navBarMob: selectDoc('#navbar-mobile'),
    tabsNav: selectDoc('.services.header .tabs'),
    invisibleTabs: selectDoc('.services.header .invisible-tabs'),
    header: selectDoc('.services.header'),
    titles: selectArr(('.header-services .tab-title')),
    quotesSlider: selectArr(('.quotes-slider')),
    servicesQ: selectArr(('.services .q')),
    servicesContacts: selectArr(('.services #ContactForm .message')),

    contactInput: selectDoc('input[name="contact[service]"]'),
    contactForm: selectDoc('#ContactForm'),
    contactSubmit: selectDoc('#ContactForm button.btn'),
    contactResponse: selectDoc('#ContactForm .success-response'),
    contactEmail: selectDoc('#ContactForm #ContactForm-email'),
    contactName: selectDoc('#ContactForm #ContactForm-name'),
    responseContainer: selectDoc('#ws-template-two .response-container'),
    gValue: '',
    authKey: '',

    glides: [],

    //FAQs
    openQuestions: selectArr(('.open-question')),
    questions: selectDoc('.questions'),
    questionsBodies: selectArr(('.questions .answer')),
    openQuestion: selectDoc('.open-question.open'),
    questionsQ: selectArr(('.questions .q')),

    //General
    tab: selectDoc('.tabs'),
    tabs: selectArr(('.tabs .tab'))
}

const checkUrl = async () => {
    let params = new URL(document.URL).searchParams;
    if (params.get('tab')) {
        let title = selectDoc(`#${params.get('tab')}`);
        const titles = [].slice.call(props.tabsButtons);

        /**
         * Questions
         */
        addClassAll([].slice.call(props.questionsQ), 'hide')

        /**
         * Services
         */
        addClassAll(props.servicesQ, 'hide')
        addClassAll(props.servicesContacts, 'hide')
        removeClassAll(titles, 'default')
        toggleClass(title, 'default')
        toggleClassAll(selectAll('.q.' + title.id), 'hide')

        props.defaultTab = selectDoc('.tab-title.default');
    }
}

const ajaxContactCall = (button, inputs = [], requestData = {}, endpoint = '', captchaContainer, successContainer) => {
    button.disabled = true;
    button.style.opacity = '0.5';

    let error = false;
    inputs.map(input => {
        if (input) {
            let inputMsg = selectDoc('.' + input.id + '.error-input')

            /**
             * Clean error
             */
            input.classList.remove('error')
            inputMsg.classList.remove('show')
            inputMsg.innerText = ''

            /**
             * Validate empty
             */
            if (inputEmpty(input.value)) {
                error = true;
                input.classList.add('error')

                inputMsg.innerText = "Field can't be empty."
                inputMsg.classList.add('show')
            } else {
                /**
                 * Validate email
                 */
                if (input.id.includes('Email') || input.id.includes('email')) {
                    if (!inputEmail(input.value)) {
                        error = true;
                        input.classList.add('error')

                        inputMsg.innerText = "Please enter a valid email address."
                        inputMsg.classList.add('show')
                    }
                }

                /**
                 * Validate password
                 */
                if (input.id.includes('password') || input.id.includes('Password')) {
                    if (!inputPassword(input.value)) {
                        error = true;
                        input.classList.add('error')

                        inputMsg.innerText = "Please enter a valid password."
                        inputMsg.classList.add('show')
                    }
                }
            }
        }
    });

    if (!error) {
        /**
         * Check if captcha params required
         */
        if (props.authKey && props.gValue) {
            requestData = {
                "authenticity_token": props.authKey,
                "g-recaptcha-response": props.gValue,
            }
        }

        /**
         * Prepare request data
         */
        let formBody = []
        for (var property in requestData) {
            if (requestData[property] != '') {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(requestData[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
        }

        /**
         * Make call
         */
        ajax('POST',
            endpoint,
            formBody.join('&'),
            'application/x-www-form-urlencoded'
        ).then(function (response) {
            button.disabled = false;
            button.style.opacity = '1';
            response = JSON.parse(response).response;

            /**
             * If Captcha present on HTML response
             */
            if (response.includes('shopify-challenge__container')) {

                /**
                 * Render response
                 */
                props.responseContainer.innerHTML = response;

                /**
                 * Extract auth keys
                 */
                props.authKey = (selectDoc("input[name='authenticity_token']").value);

                let siteKey = '';
                selectArr(("script")).map(script => {
                    if (script.innerHTML.includes('recaptchaCallback')) {
                        script.innerHTML.split(':').map(portion => {
                            if (portion.includes('size')) {
                                siteKey = portion.split(',')[0]
                            }
                        })
                    }
                })

                /**
                 * Clean response
                 */
                props.responseContainer.innerHTML = ''

                /**
                 * Render captcha
                 */
                let scriptTag = document.createElement('script'),
                    scriptTagTwo = document.createElement('script');

                scriptTagTwo.innerHTML = `
                        var onCaptchaSuccessCustom = function () {
                            var event;
                            try {
                                event = new Event('captchaSuccessCustom', {bubbles: true, cancelable: true});
                            } catch (e) {
                                event = document.createEvent('Event');
                                event.initEvent('captchaSuccessCustom', true, true);
                            }
                            window.dispatchEvent(event);
                        }
                        
                        var recaptchaCallbackCustom = function () {
                            let widgetId = grecaptcha.render('${captchaContainer}', {
                                sitekey: ${siteKey},
                                size: (window.innerWidth > 320) ? 'normal' : 'compact',
                                callback: 'onCaptchaSuccessCustom',
                            })
                        ;};
                        `
                props.responseContainer.appendChild(scriptTagTwo)

                scriptTag.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaCallbackCustom&amp;render=explicit&amp;hl=en';
                props.responseContainer.appendChild(scriptTag)

                /**
                 * Listen response
                 */
                window.addEventListener('captchaSuccessCustom', function () {
                    let responseInput = document.querySelector('.g-recaptcha-response');
                    props.gValue = responseInput.value
                }, false);

            } else {
                props.gValue = '';
                props.authKey = '';

                props.responseContainer.innerHTML = response;
                let success = selectDoc(successContainer)
                props.responseContainer.innerHTML = '';

                if (success) {
                    selectDoc('#' + captchaContainer).innerHTML = ''
                    props.contactResponse.innerText = success.innerText

                    setTimeout(function () {
                        button.classList.add('success');
                        button.innerText = 'Submitted';
                        let successmsg = selectDoc('.success-msg');
                        if(successmsg){
                            successmsg.classList.add('show')
                        }
                        // setTimeout(function () {
                        //     location.reload();
                        // }, 3000)

                    }, 1000)
                }
            }
        });
    } else {
        button.disabled = false;
        button.style.opacity = '1';
    }
}

const initContactForm = () => {
    if (props.contactSubmit) {
        event(props.contactSubmit, 'click', function (e) {
            e.preventDefault()
            let contactBody = selectDoc(`#ContactForm .${props.contactInput.value}.message textarea`);

            ajaxContactCall(
                props.contactSubmit,
                [props.contactEmail, props.contactName, contactBody],
                {
                    "contact[service]": props.contactInput.value,
                    "contact[email]": props.contactEmail.value,
                    "contact[name]": props.contactName.value,
                    "contact[body]": contactBody.value,
                    "form_type": 'contact',
                    "utf8": '✓'
                },
                "/contact",
                'g-recaptcha-contact',
                '#ContactForm .form-message--success',
                '')
        })

        //Textarea height
        selectArr('#ContactForm textarea').map(textarea => {
            textarea.style.height = `${textarea.getAttribute('placeholder').length - 50}px`
        })
    }
}

const initTabBar = async () => {
    function calcWidth() {
        let total = 0,
            screenWidth = window.innerWidth - (window.innerWidth * 0.15); //left padding * 2
        props.tabs.map(tab => {
            total += tab.getBoundingClientRect().width
        })

        if (total > 0 && total <= screenWidth) {
            props.tab.style.width = total + 'px'
        } else {
            props.tab.style.width = '100%'
        }
    }

    if (props.tab) {
        /**
         * Width
         */
        event(window, 'resize', calcWidth);
        calcWidth();
        props.tab.style.opacity = '1'
    }
}

const initServicesTabBar = async () => {
    //Show current tab
    if (props.defaultTab) {
        let defaultContactForm = selectDoc(`#ContactForm .message.${props.defaultTab.id}`);

        removeClassAll(selectArr(('.q.' + props.defaultTab.id)), 'hide')
        if (defaultContactForm) {
            defaultContactForm.classList.remove('hide')
        }

        if (props.contactInput) {
            props.contactInput.value = props.defaultTab.id
        }

        /**
         * Hide form from first tab
         */
        if (props.contactForm && props.defaultTab.id == 'overview') {
            props.contactForm.style.display = 'none'
        }
    }

    let firstTab = null,
        lastPos = 0;

    const titles = [].slice.call(props.tabsButtons);
    titles.map((title, index) => {
        /**
         * Rounded edge animation
         */
        title.setAttribute('data-pos', index)
        let rounded = selectDoc(`#${title.id} ~ .rounded-edge`)
        if (index < 1) {
            firstTab = title;
            rounded.style.left = '50%'
            title.classList.add('left')
        } else {
            rounded.style.right = '50%'
            title.classList.add('right')
        }

        event(title, 'click', function () {

            //Animation
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            let rounded = selectDoc(`#${title.id} ~ .rounded-edge`)
            if (rounded) {
                if (title.getAttribute('data-pos') > lastPos) {
                    rounded.style.left = 'auto'
                    title.classList.remove('left')

                    rounded.style.right = '50%'
                    title.classList.add('right')
                } else {
                    rounded.style.right = 'auto'
                    title.classList.remove('right')

                    rounded.style.left = '50%'
                    title.classList.add('left')
                }

                titles.map(otherTab => {
                    let pos = otherTab.getAttribute('data-pos'),
                        otherRounded = selectDoc(`[data-pos="${pos}"] ~ .rounded-edge`);
                    if (otherRounded) {
                        if (title.getAttribute('data-pos') < pos) {
                            otherRounded.style.left = 'auto'
                            otherRounded.style.right = '50%'
                        } else {
                            if (title.getAttribute('data-pos') > pos) {
                                otherRounded.style.right = 'auto'
                                otherRounded.style.left = '50%'
                            }
                        }
                    }
                })
            }
            lastPos = title.getAttribute('data-pos')

            /**
             * Questions
             */
            addClassAll([].slice.call(props.questionsQ), 'hide')

            /**
             * Services
             */
            addClassAll(props.servicesQ, 'hide')
            addClassAll(props.servicesContacts, 'hide')
            removeClassAll(titles, 'default')
            toggleClass(title, 'default')
            toggleClassAll(selectAll('.q.' + title.id), 'hide')
            toggleClassAll(selectAll('.message.' + title.id), 'hide')

            if (props.contactInput) {
                props.contactInput.value = title.id
            }

            window.history.replaceState({}, 'tab', '?tab=' + title.id);

            props.quotesSlider.map(slider => {
                toggleClass(slider, 'hide-opacity')
            })

            setTimeout(function () {
                props.glides.map(glider => {
                    glider.update();
                })
                props.quotesSlider.map(slider => {
                    toggleClass(slider, 'hide-opacity')
                })
            }, 700)

            /**
             * Hide form from first tab
             */
            if (props.contactForm) {
                if (title.id == 'overview') {
                    props.contactForm.style.display = 'none'
                } else {
                    props.contactForm.style.display = 'block'
                }
            }

        })
    })

    /**
     * Services Scroll Event
     */
    let nav;
    if (props.tabsNav) {
        event(window, 'scroll', function () {
            let navSizes = props.tabsNav.getBoundingClientRect();

            /**
             * Screen size
             */
            if (props.pageContainer.getBoundingClientRect().width < 768) {
                nav = props.navBarMob;
            } else {
                nav = props.navBarDesktop;
            }

            /**
             * Sticky
             */
            if (navSizes.top <= nav.getBoundingClientRect().height) {
                if (!hasClass(props.tabsNav, 'sticky-nav')) {
                    toggleClass(props.tabsNav, 'sticky-nav')
                    props.tabsNav.style.top = nav.getBoundingClientRect().height + 'px'
                    toggleClass(props.invisibleTabs, 'visible')
                }
            }

            /**
             * Un-sticky
             */
            if (((props.invisibleTabs.getBoundingClientRect().top - navSizes.height) > 0 || window.scrollY === 0) && hasClass(props.tabsNav, 'sticky-nav')) {
                toggleClass(props.tabsNav, 'sticky-nav')
                toggleClass(props.invisibleTabs, 'visible')
            }
        })
    }

}

const initQuestions = async () => {
    props.openQuestions.map(btn => event(btn, 'click', function () {
        const currentBody = selectDoc('.' + btn.id);

        props.questionsBodies.map(body => {
            body.style.height = 0;
        })
        let height = 0;
        selectArr(('.' + btn.id + ' p')).map(p => {
            height += p.getBoundingClientRect().height
        })
        currentBody.style.height = (height + 25) + 'px'

        let isAnyOpen = selectDoc('.open-question.open');
        if (!hasClass(btn, 'open') && isAnyOpen) {
            removeClassAll(props.openQuestions, 'open')
            addClassAll(props.questionsBodies, 'close')
        } else {
            toggleClass(props.questions, 'open')
        }

        toggleClass(btn, 'open')
        toggleClass(currentBody, 'close');
    }))
}

const setLinksTarget = () => {
    const links = selectArr(('.faq-page a'))
    links.map(link => {
        link.setAttribute("target", "_blank");
    })
};

const initializer = () => {
    checkUrl();
    initTabBar();
    initServicesTabBar();
    initQuestions();
    initContactForm();
    setLinksTarget();

    props.quotesSlider.map(slider => {
        let glider = initSlider('#' + slider.id, {
            perView: 1,
            rewind: false,
            peek: {
                before: 0,
                after: 0
            }
        });
        props.glides.push(glider)
    })
}

export const TemplateTwo = {
    init: () => initializer()
}
